import React, { useState } from 'react';
import '../styles/styles.css';

const QuizOptionsModal = ({ visible, onConfirm, onCancel }) => {
    const [numQuestions, setNumQuestions] = useState('5');
    const [error, setError] = useState('');

    const handleConfirm = () => {
        const num = parseInt(numQuestions, 10);
        if (isNaN(num) || num < 1 || num > 50) {
            setError('Please enter a number between 1 and 50.');
            return; // Do not resolve, let user correct input
        }
        setError('');
        try {
            console.log('[QuizOptionsModal] Calling onConfirm with:', { quizType: 'standard', numQuestions: num });
            onConfirm({ quizType: 'standard', numQuestions: num });
        } catch (error) {
            console.error('[QuizOptionsModal] Error in onConfirm:', error);
            setError('An error occurred. Please try again.');
        }
    };

    const handleCancel = () => {
        console.log('[QuizOptionsModal] handleCancel called');
        onCancel();
    };

    if (!visible) return null;

    return (
        <div className="modal-overlay" style={{ pointerEvents: 'auto' }}>
            <div className="modal-container quiz-options-modal">
                <h2 className="modal-title">Select Quiz Options</h2>
                <div className="input-container">
                    <label className="modal-label">Number of Questions</label>
                    <input
                        className="text-input"
                        type="number"
                        value={numQuestions}
                        onChange={(e) => {
                            setNumQuestions(e.target.value);
                            setError('');
                        }}
                        placeholder="Enter 1-50"
                        min="1"
                        max="50"
                    />
                </div>
                {error && <p className="error-text">{error}</p>}
                <div className="modal-footer">
                    <button type="button" className="button confirm-button" onClick={handleConfirm}>Confirm</button>
                    <button type="button" className="button button--ghost" onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default QuizOptionsModal;